import { Box, TextField } from "@mui/material";
import useOperationTranslation from "../../hooks/useOperationTranslation";
import GenericFilterBox from "../common/GenericFilterBox";
import { TypesOfData } from "./types";

interface Props {
  searchData: TypesOfData.SearchFuncTypes;
  setSearchData: (values: TypesOfData.SearchFuncTypes) => void;
  setFormData: (values: TypesOfData.SearchFuncTypes) => void;
  resetData: () => void;
  refreshTable: () => void;
}

const SearchLogisticCompoundModal = (props: Props) => {
  const t = useOperationTranslation();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.setSearchData({
      ...props.searchData,
      [event.target.name]: event.target.value,
    });
  };

  const SumbitForm = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    props.setFormData(props.searchData);
  };

  return (
    <form
      id="searchForm"
      onSubmit={(event: React.FormEvent<HTMLFormElement>) => SumbitForm(event)}
    >
      <GenericFilterBox
        formId="searchForm"
        onReset={props.resetData}
        showExtrasFilters={false}
      >
        <Box>
          <TextField
            variant="standard"
            fullWidth
            id="name"
            name="name"
            value={props.searchData?.name || ""}
            label={t("logisticCompound.table.name")}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              handleChange(event)
            }
            inputProps={{
              pattern: "[^%*$)(\"+&?^~Â`£=!@'_/§#-]{0,}",
              onInput: (event) => {
                if (event.currentTarget.validity.patternMismatch) {
                  event.currentTarget.setCustomValidity(
                    t("vehicle.filterModal.regexMessage")
                  );
                } else {
                  event.currentTarget.setCustomValidity("");
                }
              },
            }}
          />
        </Box>
        <Box>
          <TextField
            variant="standard"
            fullWidth
            id="bpCode"
            name="bpCode"
            value={props.searchData?.bpCode || ""}
            label={t("logisticCompound.table.bpCode")}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              handleChange(event)
            }
            inputProps={{
              pattern: "[^%*$)(\"+&?^~Â`£=!@'_/§#-]{0,}",
              onInput: (event) => {
                if (event.currentTarget.validity.patternMismatch) {
                  event.currentTarget.setCustomValidity(
                    t("vehicle.filterModal.regexMessage")
                  );
                } else {
                  event.currentTarget.setCustomValidity("");
                }
              },
            }}
          />
        </Box>
      </GenericFilterBox>
    </form>
  );
};

export default SearchLogisticCompoundModal;
